import { fetchApi } from '@/config/axiosSetting';
import { PatchOwnerInitialInfoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchOwnerInitialInfo/patchOwnerInitialInfoQuery.type';

export const patchOwnerInitialVisitInfo = (
  params: PatchOwnerInitialInfoQueryParamsType,
) => {
  return fetchApi.patch(
    `initial/reports/${params.id}/insurer_information/personal_information/`,
    params?.data,
    {
      params: {
        id: params?.id,
      },
    },
  );
};
